import React from "react";
import { Button } from "src/components/button";

interface IDefaultPageHeaderProps {
  title: string;
  onAdd: () => void;
  buttonLabel?: string;
}

export const DefaultPageHeader: React.FC<IDefaultPageHeaderProps> = ({
  title,
  onAdd,
  buttonLabel = "Add new",
}) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-2xl font-medium" style={{ color: "#344054"}}>{title}</h1>
      <Button
        className="flex xs:h-[40px] sm:h-[40px] md:h-[48px] lg:h-[48px] xl:h-[48px] xs:p-[8px] sm:p-[8px]  md:p-[15px] lg:p-[15px] xl:p-[15px] justify-center items-center gap-[8px] rounded-[40px] [background:var(--main-gradient,linear-gradient(90deg,#145BF0_0%,#1DC66D_100%))]"
        onClick={() => onAdd && onAdd()}
      >
        <i className="bi bi-plus"></i>
        {buttonLabel}
      </Button>
    </div>
  );
};
